import { atom } from 'jotai';
import { BulkCreateForAssembliesInput } from '@/__generated__/graphql';

export const pofCommentsState = atom<BulkCreateForAssembliesInput | undefined | null>(undefined);

export const cofCommentsState = atom<BulkCreateForAssembliesInput | undefined | null>(undefined);

export const transitionCommentsState = atom<BulkCreateForAssembliesInput | undefined | null>(
  undefined
);

export const openState = atom<boolean>(false);

export const selectedField = atom<string>('');

export const titleState = atom<string>('');

export const selectedRiskTab = atom<string>('');

export const riskView = atom<'calculations' | 'summary' | undefined>(undefined);

export const transitionCalculated = atom<boolean>(false);

export const editorExpanded = atom<boolean>(false);

export const invalidDamageClassCount = atom<number>(0);

export const ignoreMissingComments = atom<boolean>(false);

export const suppressMissingCommentsCheck = atom<boolean>(false);

export const showMissingCommentsDialog = atom<boolean>(false);

export const showBulkCommentsDialog = atom<boolean>(false);

export const isBulkCommentsUpdateRequested = atom<boolean>(false);

export const openTaskModal = atom<boolean>(false);

export const selectedCommentId = atom<string | undefined>(undefined);

export const selectedCommentText = atom<string>('');

export const showClearValuesDialog = atom<boolean>(false);

export const continueWithClearValues = atom<boolean>(false);

export const openDescriptionModal = atom<boolean>(false);
